const {
  select,
  siblings,
  addClass,
  removeClass,
} = DOM;

const ProductDetails = {
  root: null,
  bindTab(target) {
    const button = target.closest('button[data-tab]');
    if (button) {
      const tab = button.dataset.tab;
      const content = select(`[data-content="${tab}"]`);
      removeClass(siblings(button), 'is_active');
      addClass(button, 'is_active');
      removeClass(siblings(content), 'is_show');
      addClass(content, 'is_show');
    }
  },
  bindHandler() {
    this.root.addEventListener('click', (e) => {
      const target = e.target;
      this.bindTab(target);
    });
  },
  init() {
    const detail = select('[data-selector="product.details"]');

    if (detail) {
      this.root = detail;
      this.bindHandler();
    }
  }
}

export default ProductDetails;